var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.boolValue)?_c('d2-icon',{staticClass:"text-success",attrs:{"name":"check"}}):(_vm.boolValue === false)?_c('d2-icon',{staticClass:"text-danger",attrs:{"name":"times"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }